// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"108":"3d01263f974c6b23e2cd","245":"ed09aea6436679620d36","452":"29c7930c792a2b5b940f"}[chunkId] + ".js";
};